import script from "./BulkEditCustomFieldsHub.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkEditCustomFieldsHub.vue?vue&type=script&setup=true&lang=js"

import "./BulkEditCustomFieldsHub.vue?vue&type=style&index=0&id=2454b26c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2454b26c"]])

export default __exports__